import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GridService } from '../shared/grid/grid.service';
import { Ppe } from '../models/ppe.model';

@Injectable({
    providedIn: 'root'
})
export class PpeService extends GridService<Ppe> {

    constructor(http: HttpClient) {
        super('Ppe', http);
    }
}
